"use client";

import { BSRImageSearch } from "./bsr/BSRImageSearch";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { ImageSearch as LegacyImageSearch } from "./legacy/ImageSearch";

export const ImageSearch = createBSRExperimentIcon(
  LegacyImageSearch,
  BSRImageSearch
);
